import React, { useEffect, useState } from "react";
import { parentalApi } from "../family/parentalApi";

// Parental Control 13+ (sheet 1.4.2): the suitability rating a poster chooses when posting.
// Unticked = a general post (the default). Ticked = a mature post, which is never shown to anyone under 18.
// An account under 18 cannot make a mature post, so for them the box is not shown at all (the server refuses it as well).
// The account's age comes from the Family status the page already uses; if it cannot be read, the box is shown and the server decides.
export default function MatureToggle({ checked, onChange, what = "post" }) {
  const [youth, setYouth] = useState(false);
  useEffect(() => {
    let alive = true;
    parentalApi.me().then((d) => { if (alive && d && d.kind === "youth") setYouth(true); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  if (youth) return null;
  return (
    <label className="flex items-start gap-2 mt-3 text-sm text-gray-700 cursor-pointer" data-testid="mature-toggle">
      <input type="checkbox" className="mt-1" checked={!!checked} onChange={(e) => onChange(e.target.checked)} />
      <span>
        <strong>This {what} is for a mature audience (18+)</strong>
        <span className="block text-xs text-gray-500">Mature {what}s are hidden from accounts under 18.</span>
      </span>
    </label>
  );
}
